import { useState } from 'react';
import UpgradeModal from './UpgradeModal';

/**
 * Inline locked-content overlay shown where premium content would render.
 * Used for partial-content features (predictions narrative, briefing full text,
 * injury explanation, weather breakdown). Companion to LockedFeatureCard
 * which handles full-page route-level locks.
 *
 * @param {Object} props
 * @param {string} props.description - Feature-specific upgrade pitch
 * @param {string} props.triggerFeature - For analytics, passed to UpgradeModal
 */
export default function LockedContentOverlay({ description, triggerFeature }) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div className="rounded-md border border-dashed border-[#cbd5e1] dark:border-[#2d3748] bg-[#f8fafc] dark:bg-[#0f1219] px-4 py-5 text-center">
        <svg className="w-7 h-7 text-[#94a3b8] dark:text-[#505a6e] mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
        </svg>
        <p className="text-[13px] text-[#4b5563] dark:text-[#94a3b8] mb-3 max-w-sm mx-auto leading-relaxed" style={{ fontFamily: 'var(--font-sans)' }}>
          {description}
        </p>
        <button
          onClick={() => setModalOpen(true)}
          className="rounded-md bg-[#005BB3] px-4 py-1.5 text-[13px] font-medium text-white hover:bg-[#004a93] transition-colors duration-150"
          style={{ fontFamily: 'var(--font-sans)' }}
        >
          Upgrade to Pro
        </button>
      </div>

      <UpgradeModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        suggestedTier="pro"
        triggerFeature={triggerFeature}
      />
    </>
  );
}
